import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-display-card',
  templateUrl: './display-card.component.html',
  styleUrls: ['./display-card.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
// This component is solely used to display projected text with a bit of styling.
export class DisplayCardComponent implements OnInit {
  constructor(private ChangeDetectorRef: ChangeDetectorRef) {}

  // This parameter can be set to configure the panel height css.
  // 'fit' will make the display-card panel height shrink/grow to fit the content contained in the panel.
  // 'fill' will make the display-card panel height fill the space of the parent container (set height: 100%)
  @Input() panelHeight: 'fit' | 'fill' = 'fill';
  @Input() header?: string;
  @Input() headerPosition: 'center' | 'left' | 'right' = 'center';
  @Input() innerPanel: boolean = false;
  @Input() justifyContent:
    'start' | 'end' | 'between' | 'evenly' | 'center' | 'around' = 'between';
  @Input() panelStyle?: { [key: string]: string };
  // Determines if a card is selected. If it is, applies a border to represent the selection.
  @Input() isSelected: boolean = false;

  ngOnInit(): void {
    this.ChangeDetectorRef.markForCheck();
  }
}
